// import { Dev } from "@/ui/pages/root/dev/Dev";
// import { Login } from "@/ui/pages/root/login/Login";

import { RouteObject } from "react-router-dom";

import { Register } from "ui/pages/auth/register/Register";
import { AuthLayout } from "ui/pages/layouts/AuthLayout";
import { Auth } from "ui/pages/auth/Auth";
import { Login } from "ui/pages/auth/Login";
import { TellUsMore } from "ui/pages/auth/register/TellUsMore";
import { ForgotPassword } from "ui/pages/auth/ForgotPassword";
import { RecoverPassword } from "ui/pages/auth/RecoverPassword";
import { ChooseAccountType } from "ui/pages/auth/ChooseAccountType";
import { ConfirmPlanChoice } from "ui/pages/auth/register/ConfirmPlanChoice";
import { QuoteRequest } from "ui/pages/auth/register/QuoteRequest";

export const authRoutes: RouteObject[] = [
  {
    path: "auth",
    element: (
      <AuthLayout>
        <Auth />
      </AuthLayout>
    ),
  },
  {
    path: "login",
    element: (
      <AuthLayout>
        <Login />
      </AuthLayout>
    ),
  },
  {
    path: "register",
    element: (
      <AuthLayout>
        <Register />
      </AuthLayout>
    ),
  },
  {
    path: "tell-us-more",
    element: (
      <AuthLayout>
        <TellUsMore />
      </AuthLayout>
    ),
  },
  {
    path: "forgot-password",
    element: (
      <AuthLayout>
        <ForgotPassword />
      </AuthLayout>
    ),
  },
  {
    path: "recover-password",
    element: (
      <AuthLayout>
        <RecoverPassword />
      </AuthLayout>
    ),
  },
  {
    path: "account-type",
    element: (
      <AuthLayout>
        <ChooseAccountType register />
      </AuthLayout>
    ),
  },
  {
    path: "choice-confirmation",
    element: (
      <AuthLayout>
        <ConfirmPlanChoice />
      </AuthLayout>
    ),
  },
  {
    path: "quote-request",
    element: (
      <AuthLayout>
        <QuoteRequest />
      </AuthLayout>
    ),
  },
];
